import { render } from "./Occupations.vue?vue&type=template&id=643fd971"
import script from "./Occupations.vue?vue&type=script&lang=js"
export * from "./Occupations.vue?vue&type=script&lang=js"
script.render = render

export default script